import { ButtonWithSpinner, ToastCustom } from "@components";
import { useMutation } from "@tanstack/react-query";
import { useMemo } from "react";
import { toast } from "sonner";
import { summaryAnswerInitialize } from "../services";
import { useChecklistProgressStore, useChecklistStore } from "../store";
import { ChecklistAnswerInitializeMode } from "../types";
import { mergeChecklistAnswerResponse } from "../utils/checklist-answer.utils";
import { LastAnswers, SummaryImageDetailsCarousel } from "./";

export const SummaryStep = () => {
	const checklist = useChecklistStore((state) => state.checklist);
	const setChecklist = useChecklistStore((state) => state.setChecklist);

	const setCurrentStep = useChecklistProgressStore(
		(state) => state.setCurrentStep
	);
	const setTotalSteps = useChecklistProgressStore(
		(state) => state.setTotalSteps
	);
	const { summary } = checklist?.answerData || {};

	const data = checklist;

	const { mutate: mutateReusedAnswer, isPending: isPendingReused } =
		useMutation({
			mutationKey: ["checklist:summary-answer-initialize:reused"],
			mutationFn: summaryAnswerInitialize,
			onSuccess: (response) => {
				setChecklist({
					...data,
					answerData: mergeChecklistAnswerResponse(data?.answerData, response),
				});
				if (response.checklistAnswer?.sections?.length) {
					const sectionsWithGeneralDataScreen =
						response.checklistAnswer?.sections?.length + 2;

					setCurrentStep(1);
					setTotalSteps(sectionsWithGeneralDataScreen);
				}
			},
			onError: (error) => {
				if (error?.message) {
					toast(<ToastCustom description={error?.message} title="Erro" />);
				}
			},
		});

	const { mutate: mutateNewAnswer, isPending: isPendingNew } = useMutation({
		mutationKey: ["checklist:summary-answer-initialize:new"],
		mutationFn: summaryAnswerInitialize,
		onSuccess: (response) => {
			setChecklist({
				...data,
				answerData: mergeChecklistAnswerResponse(data?.answerData, response),
			});
			if (response.checklistAnswer?.sections?.length) {
				const sectionsWithGeneralDataScreen =
					response.checklistAnswer?.sections?.length + 2;

				setCurrentStep(1);
				setTotalSteps(sectionsWithGeneralDataScreen);
			}
		},
		onError: (error) => {
			if (error?.message) {
				toast(<ToastCustom description={error?.message} title="Erro" />);
			}
		},
	});

	const isLoading = useMemo(
		() => isPendingReused || isPendingNew,
		[isPendingReused, isPendingNew]
	);

	const handleReusedAnswers = () => {
		if (!(summary?.answerToken && summary?.id)) {
			return;
		}
		mutateReusedAnswer({
			answerId: summary.id,
			body: {
				answerToken: summary.answerToken,
				initializeMode: ChecklistAnswerInitializeMode.Reused,
			},
		});
	};

	const handleNewAnswer = () => {
		if (!(summary?.answerToken && summary?.id)) {
			return;
		}
		mutateNewAnswer({
			answerId: summary.id,
			body: {
				answerToken: summary.answerToken,
				initializeMode: ChecklistAnswerInitializeMode.NewAnswer,
			},
		});
	};

	return (
		<div className="flex h-screen w-full flex-1 flex-col gap-6">
			<SummaryImageDetailsCarousel />

			<LastAnswers />

			<div className="sticky bottom-0 left-0 mt-auto w-full border-primary border-t bg-secondary px-4 pt-4 pb-8 text-center">
				<div className="mx-auto flex w-full max-w-[456px] gap-2">
					<ButtonWithSpinner
						className="w-1/2"
						disabled={isLoading}
						isLoading={isPendingNew}
						onClick={handleNewAnswer}
						type="button"
						variant="secondary"
					>
						Novo checklist
					</ButtonWithSpinner>
					<ButtonWithSpinner
						className="w-1/2"
						disabled={isLoading}
						isLoading={isPendingReused}
						onClick={handleReusedAnswers}
						type="button"
					>
						Aproveitar checklist
					</ButtonWithSpinner>
				</div>
			</div>
		</div>
	);
};
